<template>
  <div>
    <v-menu offset-x nudge-left="6" content-class="workspace-sub-menu" v-if="children.length">
      <template v-slot:activator="{ on, attrs }">
        <button type="button" class="settings-link" v-bind="attrs" v-on="on">
          <span class="settings-icon" v-if="normalizedIcon">
            <portal-icon :size="17" :name="normalizedIcon"></portal-icon>
          </span>
          <span class="settings-label">{{label}}</span>
          <portal-icon name="chevron-right" :size="15" class="ml-auto"></portal-icon>
        </button>
      </template>
      <div class="settings-sub-menu">
        <settings-link v-for="child in children" :key="child.route || child.selectValue || child.label" :label="child.label" :route="child.route" :icon="child.icon" :select-value="child.selectValue" @selected="$emit('selected',$event)"></settings-link>
      </div>
    </v-menu>

    <button type="button" class="settings-link" :class="{ 'is-selected': isSelected }" v-else @click="handleClick">
      <span class="settings-icon" v-if="normalizedIcon">
        <portal-icon :size="17" :name="normalizedIcon"></portal-icon>
      </span>
      <span class="settings-label">{{label}}</span>
      <portal-icon v-if="isSelected" name="check" :size="16" class="settings-check"></portal-icon>
    </button>
  </div>
</template>

<script>
export default {
  name: "SettingsLink",

  props: {
    pro: {type: Boolean, required: false, default: false},
    icon: { type: String, required: false},
    label: { type: String, required: true },
    route: { type: String, required: false },
    selectValue: {type: String, required: false},
    children: { type: Array, required: false, default: () => []},
  },

  components: {},

  data: function () {
    return {}
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    handleClick: function(){
      if(this.route){
        this.$router.push(this.route);
      }
      if(this.selectValue){
        this.$emit('selected',this.selectValue);
      }
    }
  },

  computed: {
    normalizedIcon() {
      const icons = {
        light_mode: 'sun',
        dark_mode: 'moon',
        settings_brightness: 'monitor-cog',
        translate: 'languages',
        logout: 'log-out',
      };
      return icons[this.icon] || this.icon;
    },

    isSelected() {
      return Boolean(this.selectValue && this.selectValue === this.$store.state.darkMode);
    },
  },

}
</script>

<style lang="scss">
.workspace-sub-menu {
  min-width: 210px;
  padding: 6px;
  border: 1px solid var(--portal-border);
  border-radius: var(--brand-surface-radius, 14px) !important;
  background-color: var(--portal-surface);
  box-shadow: 0 16px 42px rgba(16, 17, 15, 0.18) !important;
}

.settings-sub-menu {
  display: grid;
  gap: 2px;
}
</style>

<style scoped lang="scss">
.settings-link {
  width: 100%;
  min-height: 44px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 9px;
  border: 0;
  border-radius: var(--brand-button-radius, 11px);
  background: transparent;
  color: var(--portal-text);
  font: inherit;
  font-size: 13px;
  font-weight: 560;
  line-height: 1.25;
  text-align: left;
  cursor: pointer;
}

.settings-link:hover,
.settings-link.is-selected {
  background: var(--v-gray_20-base);
}

.settings-link:focus-visible {
  outline: 2px solid var(--v-primary-base);
  outline-offset: -2px;
}

.settings-icon {
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  background: var(--v-gray_20-base);
  color: var(--portal-muted);
}

.settings-label {
  min-width: 0;
  flex: 1;
}

.settings-check {
  color: var(--v-primary-base);
}
</style>
